"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});var t=TypeError,n=function(e,r){if(e<r)throw new t("Not enough arguments");return e};exports.validateArgumentsLength=n;
